import React, { useRef, useState } from "react";
import html2pdf from "html2pdf.js";
import { Helmet } from "react-helmet";
import BackButton from "../components/BackButton";

const TextToPDFConverter = () => {
  const [inputText, setInputText] = useState("");
  const previewRef = useRef();

  const handleGeneratePDF = () => {
    const opt = {
      margin: 0.5,
      filename: "converted.pdf",
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
    };
    html2pdf().set(opt).from(previewRef.current).save();
  };

  return (
    <>
      <Helmet>
        <title>Text/HTML to PDF Converter - Free Online Tool</title>
        <meta
          name="description"
          content="Convert any text or HTML into PDF instantly with our free online tool. No sign-up, no API needed. Just copy, paste, and download!"
        />
        <meta
          name="keywords"
          content="text to PDF, HTML to PDF, online PDF converter, free PDF tool, frontend PDF converter"
        />
        <link rel="canonical" href="https://freelity.com/text-to-pdf" />
      </Helmet>

      <section className="sec-free-tools">
        <div className="container">
          <BackButton />
          <h2>Text / HTML to PDF Converter</h2>
          <div className="mb-3">
            <label className="form-label">Enter Text or HTML</label>
            <textarea
              className="form-control"
              rows={10}
              placeholder="<h1>Hello World</h1> or any plain text"
              value={inputText}
              onChange={(e) => setInputText(e.target.value)}
            ></textarea>
          </div>

          <div className="mb-3">
            <button
              className="btn btn-primary me-2"
              onClick={handleGeneratePDF}
              disabled={!inputText.trim()}
            >
              Convert to PDF
            </button>
          </div>

          <h4 className="mt-4">Preview</h4>
          <div
            ref={previewRef}
            className="p-3 border bg-light"
            dangerouslySetInnerHTML={{ __html: inputText || "<p>Preview will appear here</p>" }}
          />
        </div>
      </section>
    </>
  );
};

export default TextToPDFConverter;
